import React, { ChangeEvent, InputHTMLAttributes, useEffect, useState } from "react";

import { InputText } from "primereact/inputtext";
import { formatHexColor } from "utils/utils";
import "./ColorPicker.scss";

let timeout: NodeJS.Timeout | null = null;

type ColorPickerProps = Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
  onValueChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const ColorPicker: React.FC<ColorPickerProps> = props => {
  const {onValueChange, value: initValue, ...restProps} = props;
  const [colorText, setColorText] = useState(formatHexColor(initValue as string));


  useEffect(() => {
      setColorText(formatHexColor(initValue as string));
  }, [initValue]);


  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const regex = /^#[0-9a-fA-F]*$/;
    let { value } = e.target;
    if (value.length > 0) value = formatHexColor(value);
    if ((!regex.test(value) && value.length > 0) || value.length > 7) return;
    setColorText(value);

    if (timeout) {
			clearTimeout(timeout);
		}

    timeout = setTimeout(() => {
      if (value.length === 7) onValueChange(e);
		}, 300);
  };


  return (
    <div className="p-inputgroup flex  w-8rem">
      <InputText
        value={colorText}
        onChange={handleChange}
        className="p-inputtext-sm p-2"
        onFocus={e => e.target.select()}
      />
      <input
        type="color"
        {...restProps}
        value={(colorText as string).length === 7 ? colorText : "#000000"}
        onChange={handleChange}
        className="color-picker p-inputgroup-addon"
      />
    </div>
  );
};

export default ColorPicker;
